import api from "../../helpers/api";


export const getFavSupplierProducts = (customerId) => api.post(`customer/getfavorites-suppliers/`, customerId)


export const addFavSupplierProduct = (customerId,productID) => api.post(`customer/addfavorite-supplier/`, customerId, productID)


export const remFavSupplierProduct = (customerId, productID) => api.post(`customer/remfavorite-supplier/`,customerId, productID)